export const scheduleForm = {
  title: 'Edit Schedule',
  info: 'Changes do not apply to jobs that are currently posted. If you need to make schedule changes to existing jobs, those must be done on the jobs themselves.',
  prompts: {
    days: 'What days should your schedule follow?',
    daysDescription: 'Select the days for your schedule. You will be able to customize times as needed.',
    times: 'What times should your schedule follow?',
    name: 'Name your schedule.',
  },
  customize: {
    prompt: 'Customize your schedule',
    hint: 'Customize your schedule by changing times or unpaid breaks for specific days as necessary to accommodate your labor needs.',
  },
};
